import { render, staticRenderFns } from "./ReporteEjecucionPresupuestaria.vue?vue&type=template&id=47b66072&scoped=true"
import script from "./ReporteEjecucionPresupuestaria.vue?vue&type=script&lang=js"
export * from "./ReporteEjecucionPresupuestaria.vue?vue&type=script&lang=js"
import style0 from "./ReporteEjecucionPresupuestaria.vue?vue&type=style&index=0&id=47b66072&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47b66072",
  null
  
)

export default component.exports